<header class="header" [class.header--logged-out]="!loggedIn" [class.header--nav-collapsed]="isNavCollapsed" rmsOfflineDisable>
  <!-- Logo -->
  <a #headerLogo class="header__logo" [routerLink]="['/login']">
    <img src="../../../assets/images/logo.svg" alt="RA Capital Logo">
  </a>

  <!-- Main Navigation (visible when nav is not collapsed) -->
  <nav *ngIf="loggedIn" class="header__nav" [class.header__nav--hidden]="isNavCollapsed">
    <ul #navList class="header__nav-list">
      <ng-container *ngFor="let item of menu">
        <li
          *ngIf="item.subMenu === null || item.subMenu?.length > 0"
          #navItem
          class="header__nav-item"
          [class.header__nav-item--has-children]="item.subMenu"
          [class.header__nav-item--open]="item.open"
          [routerLinkActive]="['header__nav-item--active']"
          [ngClass]="item.className">

          <!-- Item without submenu -->
          <a
            *ngIf="!item.subMenu"
            class="header__nav-link"
            [routerLink]="item.link">
            {{ item.textKey | translate }}
            <i *ngIf="item.icon" class="fa fa-{{ item.icon }}"></i>
          </a>

          <!-- Item with submenu (hover to open on desktop) -->
          <a
            *ngIf="item.subMenu"
            class="header__nav-link"
            [ngClass]="item.className">
            {{ item.textKey | translate }}
            <i *ngIf="item.icon" class="fa fa-{{ item.icon }}"></i>
          </a>

          <!-- Dropdown Submenu -->
          <ul *ngIf="item.subMenu" class="header__submenu">
            <li
              *ngFor="let subItem of item.subMenu"
              class="header__submenu-item"
              [routerLinkActive]="['header__submenu-item--active']">

              <!-- External link -->
              <a
                *ngIf="subItem.link && isExternalLink(subItem.link)"
                class="header__submenu-link"
                [href]="subItem.link"
                target="_blank"
                (click)="onSubMenuItemClick(subItem)">
                {{ subItem.textKey | translate }}
              </a>

              <!-- Internal link -->
              <a
                *ngIf="subItem.link && !isExternalLink(subItem.link)"
                class="header__submenu-link"
                [routerLink]="subItem.link"
                (click)="onSubMenuItemClick(subItem)">
                {{ subItem.textKey | translate }}
              </a>

              <!-- Event handler (no link) -->
              <a
                *ngIf="!subItem.link"
                class="header__submenu-link"
                (click)="menuEventHubServiceHandler(subItem.clickHandler)">
                {{ subItem.textKey | translate }}
              </a>
            </li>
          </ul>
        </li>
      </ng-container>
    </ul>
  </nav>

  <!-- Action Buttons -->
  <div #headerActions *ngIf="loggedIn" class="header__actions">
    <xform-header-search
      (closeSearchPortal)="closeSearchPortal()"
      (quickSearchOpen)="quickSearchOpen($event)"
      (searchInputDetected)="searchInputDetected($event)">
    </xform-header-search>

    <rms-header-notification></rms-header-notification>

    <rms-side-panel
      [menu]="menu"
      [user]="loggedUser"
      [isOpen]="isSidePanelOpen"
      [showNavItems]="isNavCollapsed"
      (panelToggle)="onSidePanelToggle($event)"
      (logoutClicked)="logout()"
      (menuItemClicked)="onSubMenuItemClick($event)"
      (menuEventHandler)="menuEventHubServiceHandler($event)">
    </rms-side-panel>
  </div>
</header>

<!-- Modal components -->
<ng-container *ngIf="loggedIn">
  <rms-add-company></rms-add-company>
  <rms-add-portfolio></rms-add-portfolio>
  <rms-product-form></rms-product-form>
  <rms-add-crm></rms-add-crm>
</ng-container>
